import React, {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import {
    addAccount,
    setAccounts,
    setupAccount,
    setSortBy,
    updateAccount
} from "../../store/account";
import {getAccountResult, getAccounts, getTransaction} from "../../services/accounts";
import Result from "./result";
import _ from 'lodash';

function CheckingAccounts() {
    const accounts = useSelector((state => state.accounts));
    const dispatch = useDispatch();

    const [account, setAccount] = useState("");
    const [input, setInput] = useState({
        sl: 0,
        l: 0,
        ep: 0,
        sr: 0,
        r: 0,
        cm: 0
    });

    const handleChange = e => {
        const {target} = e;
        const {name} = target;
        const value = target.value;

        setInput({
            ...input,
            [name]: value
        });
    };

    const addAccountToList = () => {
        if (!account) return;

        // check is exist
        let acc = _.find(accounts.list, {address: account});
        if (acc) {
            setAccount("");
            return;
        }

        // add acc to store
        dispatch(addAccount({address: account, ...input}));
        setAccount("");
        setInput({
            sl: 0,
            l: 0,
            ep: 0,
            sr: 0,
            r: 0,
            cm: 0
        });

        // get result
        getAccountData(account);
    }

    const getAccountData = async (acc) => {
        // get account
        await getAccountResult(acc).then(result => {
            dispatch(setupAccount({address: acc, ...result.data} || null));
        });

        // get transaction
        await getTransaction(acc).then(result => {
            dispatch(updateAccount({address: acc, transaction: result} || null));
        });
    }

    useEffect(async () => {
        const data = await getAccounts();
        dispatch(setAccounts(data));

        // set up account
        data.map(async acc => {
            await getAccountData(acc.address);
        })
    }, []);

    const sortBy = (event) => {
        dispatch(setSortBy(event.target.value))
    }

    return (
        <>
            <div className="row justify-content-center">
                <div className={"col-12 mb-4"}>
                    <div className="card card-cascade wider">
                        <div className="view view-cascade grey darken-3">
                            <div className="m-3">
                                <h4 className="text-center">
                                    Checking Account
                                </h4>

                                <div className="row align-items-center mb-2">
                                    <div className="col-12 col-sm">
                                        <div className="mb-2 input-group-sm">
                                            <div className="small font-weight-bold">Address</div>
                                            <input type="text" className="form-control "
                                                   value={account}
                                                   onChange={e => setAccount(e.target.value)}/>
                                        </div>
                                    </div>
                                </div>


                                <div className="row align-items-center mb-2">
                                    <div className="col-4 col-sm input-group-sm">
                                        <div className="mb-2 input-group-sm">
                                            <div className="SL small font-weight-bold text-nowrap">Super Legend</div>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="SL"
                                                name="sl"
                                                value={input.sl}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-4 col-sm input-group-sm">
                                        <div className="mb-2 input-group-sm">
                                            <div className="L small font-weight-bold text-nowrap">Legend</div>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="L"
                                                name="l"
                                                value={input.l}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-4 col-sm input-group-sm">
                                        <div className="mb-2 input-group-sm">
                                            <div className="EP small font-weight-bold text-nowrap">Epic</div>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="EP"
                                                name="ep"
                                                value={input.ep}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-4 col-sm input-group-sm">
                                        <div className="mb-2 input-group-sm">
                                            <div className="SR small font-weight-bold text-nowrap">Super rare</div>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="SR"
                                                name="sr"
                                                value={input.sr}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-4 col-sm input-group-sm">
                                        <div className="mb-2 input-group-sm">
                                            <div className="R small font-weight-bold text-nowrap">Rare</div>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="R"
                                                name="r"
                                                value={input.r}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-4 col-sm input-group-sm">
                                        <div className="mb-2 input-group-sm">
                                            <div className="CM small font-weight-bold text-nowrap ">Common</div>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="CM"
                                                name="cm"
                                                value={input.cm}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row align-items-center mb-2">
                                    <div className="col-auto">
                                        <div className="btn btn-sm m-0 btn-black"
                                             onClick={() => addAccountToList()}> Add Account
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row sss-font">
                <div className="col">
                    <div className=" mb-3">
                        <div className="d-inline-block mr-3 form-check p-0">Sort:</div>

                        <div className="d-inline-block">
                            <div className="d-inline-block mr-3 form-check p-0">
                                <input onChange={sortBy}
                                       checked={accounts.sortBy === "roi"}
                                       className="form-check-input" type="radio" name="flexRadioDefault"
                                       id="monitorSortMode4" value="roi"/><label
                                className="form-check-label pl-4"
                                htmlFor="monitorSortMode4">ROI</label>
                            </div>

                            <div className="d-inline-block mr-3 form-check p-0">
                                <input onChange={sortBy}
                                       checked={accounts.sortBy === "amount_of_bcoin_claimed"}
                                       className="form-check-input" type="radio" name="flexRadioDefault"
                                       id="monitorSortMode2" value="amount_of_bcoin_claimed"/><label
                                className="form-check-label pl-4"
                                htmlFor="monitorSortMode2">Total Claimed</label>
                            </div>
                            <div className="d-inline-block mr-3 form-check p-0">
                                <input onChange={sortBy}
                                       checked={accounts.sortBy === "lasted_claimed"}
                                       className="form-check-input" type="radio" name="flexRadioDefault"
                                       id="monitorSortMode3" value="lasted_claimed"/><label
                                className="form-check-label pl-4"
                                htmlFor="monitorSortMode3">Lasted Claimed</label>
                            </div>

                            <div className="d-inline-block mr-3 form-check p-0">
                                <input onChange={sortBy}
                                       checked={accounts.sortBy === "funding"}
                                       className="form-check-input" type="radio" name="flexRadioDefault"
                                       id="monitorSortMode1" value="funding"/><label
                                className="form-check-label pl-4"
                                htmlFor="monitorSortMode1">Funding</label>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="col-auto">
                    Accounts: {accounts.list.length}
                </div>
            </div>


            {accounts.list.length > 0 && <div className="row">
                {_.orderBy(accounts.list, [accounts.sortBy], ['desc']).map((account, index) => {
                    return <Result key={index} data={account}/>
                })}
            </div>
            }

        </>
    );
}

export default CheckingAccounts;
